import { useState } from "react";

import PropTypes from "prop-types";

const ImageMagnifier = ({ src = null }) => {
    // const imageSize = 300;
    // const lensSize = 100;
    // const magnifiedSize = 600;
    // const backgroundSize = 1800;
    const imageSize = 300;
    const lensSize = 100;
    const magnifiedSize = 390;
    const backgroundSize = 1170;

    const scale = backgroundSize / imageSize;

    const [lensPosition, setLensPosition] = useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseMove = (e) => {
        const img = e.currentTarget;
        const { left, top, width, height } = img.getBoundingClientRect();

        let x = e.clientX - left - lensSize / 2;
        let y = e.clientY - top - lensSize / 2;

        x = Math.max(0, Math.min(x, width - lensSize));
        y = Math.max(0, Math.min(y, height - lensSize));

        setLensPosition({ x, y });
        setIsHovering(true);
    };

    const handleMouseLeave = () => {
        setIsHovering(false);
    };

    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            <div
                style={{ position: "relative" }}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
            >
                <img
                    src={src}
                    alt="Magnifiable"
                    style={{
                        width: `${imageSize}px`,
                        height: `${imageSize}px`,
                        cursor: "none",
                    }}
                />
                {isHovering && (
                    <div
                        style={{
                            position: "absolute",
                            border: "2px dashed green",
                            pointerEvents: "none",
                            left: lensPosition.x,
                            top: lensPosition.y,
                            width: lensSize,
                            height: lensSize,
                            backgroundColor: "rgba(255, 255, 255, 0)",
                        }}
                    >
                        <span
                            style={{
                                position: "absolute",
                                left: "50%",
                                top: "50%",
                                transform: "translate(-50%, -50%)",
                                color: "green",
                                fontSize: "18px",
                            }}
                        >
                            +
                        </span>
                    </div>
                )}
            </div>
            {isHovering && (
                <div
                    style={{
                        position: "absolute",
                        left: 400,
                        // left: "50%",
                        // top: "50%",
                        // transform: "translate(10%, -50%)",
                        width: `${magnifiedSize}px`,
                        height: `${magnifiedSize}px`,
                        backgroundImage: `url(${src})`,
                        backgroundSize: `${backgroundSize}px ${backgroundSize}px`,
                        backgroundPosition: `-${lensPosition.x * scale}px -${lensPosition.y * scale}px`,
                        backgroundRepeat: "no-repeat",
                        border: "1px solid #eee",
                    }}
                />
            )}
        </div>
    );
};

ImageMagnifier.propTypes = {
    src: PropTypes.string,
};

export default ImageMagnifier;
